/* ==========================================================================
   ANYSUP THEME — Core JS
   Handles: mobile nav, cart drawer, AJAX add-to-cart, quantity, variants, accordion
   ========================================================================== */

/* Prevent automatic scroll to #join-squad when the page is opened with that hash.
   Intentional clicks on "Join the squad" / hero button still work after the page has loaded. */
(function () {
  if (window.location.hash === '#join-squad') {
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }
    history.replaceState(null, document.title, window.location.pathname + window.location.search);
    window.scrollTo(0, 0);
    // also force after a short delay in case browser finishes hash-scroll later
    setTimeout(function () { window.scrollTo(0, 0); }, 0);
    setTimeout(function () { window.scrollTo(0, 0); }, 50);
  }
})();

(function () {
  'use strict';

  const qs = (sel, ctx) => (ctx || document).querySelector(sel);
  const qsa = (sel, ctx) => Array.from((ctx || document).querySelectorAll(sel));

  /* ---------------- Mobile nav ---------------- */
  const mobileToggle = qs('[data-mobile-nav-toggle]');
  const mobileNav = qs('[data-mobile-nav]');
  const mobileClose = qs('[data-mobile-nav-close]');
  const overlay = qs('[data-overlay]');

  function openMobileNav() {
    mobileNav && mobileNav.classList.add('is-open');
    overlay && overlay.classList.add('is-visible');
  }
  function closeMobileNav() {
    mobileNav && mobileNav.classList.remove('is-open');
    if (!qs('.cart-drawer.is-open')) overlay && overlay.classList.remove('is-visible');
  }
  mobileToggle && mobileToggle.addEventListener('click', openMobileNav);
  mobileClose && mobileClose.addEventListener('click', closeMobileNav);

  /* ---------------- Cart drawer ---------------- */
  const cartDrawer = qs('[data-cart-drawer]');
  const cartTriggers = qsa('[data-cart-toggle]');

  function openCartDrawer() {
    refreshCartDrawer().then(() => {
      cartDrawer && cartDrawer.classList.add('is-open');
      overlay && overlay.classList.add('is-visible');
    });
  }
  function closeCartDrawer() {
    cartDrawer && cartDrawer.classList.remove('is-open');
    if (!qs('.mobile-nav.is-open')) overlay && overlay.classList.remove('is-visible');
  }
  cartTriggers.forEach((btn) => btn.addEventListener('click', (e) => {
    e.preventDefault();
    openCartDrawer();
  }));
  overlay && overlay.addEventListener('click', () => { closeCartDrawer(); closeMobileNav(); });
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-cart-drawer-close]')) closeCartDrawer();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { closeCartDrawer(); closeMobileNav(); }
  });

  async function refreshCartDrawer() {
    try {
      const sectionUrl = window.location.pathname + (window.location.search ? window.location.search + '&' : '?') + 'section_id=cart-drawer';
      const res = await fetch(sectionUrl);
      const html = await res.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newDrawer = doc.querySelector('[data-cart-drawer]');
      if (newDrawer && cartDrawer) {
        cartDrawer.innerHTML = newDrawer.innerHTML;
      }
      updateCartCount();
    } catch (err) {
      console.error('Cart drawer refresh failed', err);
    }
  }

  async function updateCartCount() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      qsa('[data-cart-count]').forEach((el) => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
    } catch (err) { /* noop */ }
  }
  updateCartCount();

  /* ---------------- AJAX Add to cart ---------------- */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-add-to-cart-form]');
    if (!form) return;
    e.preventDefault();

    const submitBtn = form.querySelector('[type="submit"]');
    const originalText = submitBtn ? submitBtn.textContent : '';
    if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Adding...'; }

    try {
      const formData = new FormData(form);
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      });
      if (!res.ok) {
        const err = await res.json();
        throw new Error(err.description || 'Could not add to cart');
      }
      await refreshCartDrawer();
      cartDrawer && cartDrawer.classList.add('is-open');
      overlay && overlay.classList.add('is-visible');
    } catch (err) {
      alert(err.message || 'Something went wrong. Please try again.');
    } finally {
      if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = originalText; }
    }
  });

  /* ---------------- Cart line quantity / remove (event delegation) ---------------- */
  document.addEventListener('click', async (e) => {
    const qtyBtn = e.target.closest('[data-qty-change]');
    if (qtyBtn) {
      const line = qtyBtn.closest('[data-cart-line]');
      const input = line.querySelector('[data-qty-input]');
      let qty = parseInt(input.value, 10) || 1;
      qty += parseInt(qtyBtn.dataset.qtyChange, 10);
      if (qty < 0) qty = 0;
      await updateLineQty(line.dataset.cartLine, qty);
    }
    const removeBtn = e.target.closest('[data-cart-line-remove]');
    if (removeBtn) {
      e.preventDefault();
      await updateLineQty(removeBtn.dataset.cartLineRemove, 0);
    }
  });

  async function updateLineQty(key, qty) {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      await refreshCartDrawer();
      if (qs('[data-cart-page]')) window.location.reload();
    } catch (err) {
      console.error(err);
    }
  }

  /* ---------------- Product quantity selector (PDP) ---------------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-pdp-qty-change]');
    if (!btn) return;
    const wrapper = btn.closest('.quantity-selector');
    const input = wrapper.querySelector('input');
    let val = parseInt(input.value, 10) || 1;
    val += parseInt(btn.dataset.pdpQtyChange, 10);
    if (val < 1) val = 1;
    input.value = val;
  });

  /* ---------------- Accordion (product info) ---------------- */
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('.accordion-item__trigger');
    if (!trigger) return;
    const content = trigger.nextElementSibling;
    const isOpen = content.classList.contains('is-open');
    trigger.closest('.product-info__accordion').querySelectorAll('.accordion-item__content').forEach(c => c.classList.remove('is-open'));
    if (!isOpen) content.classList.add('is-open');
  });

  /* ---------------- Variant selection -> update price/image/availability ---------------- */
  qsa('[data-product-form]').forEach((form) => {
    const productJsonEl = form.querySelector('[data-product-json]');
    if (!productJsonEl) return;
    let product;
    try { product = JSON.parse(productJsonEl.textContent); } catch (e) { return; }

    const optionInputs = qsa('[data-option-index]', form);
    const priceEl = qs('[data-product-price]', form.closest('.product-main') || document);
    const idInput = form.querySelector('[name="id"]');

    function getSelectedOptions() {
      const selected = [];
      optionInputs.forEach((group) => {
        const checked = group.querySelector('input:checked, select');
        if (checked) selected[parseInt(group.dataset.optionIndex, 10)] = checked.value || checked.options[checked.selectedIndex].value;
      });
      return selected;
    }

    function findVariant(selected) {
      return product.variants.find(v => {
        return selected.every((val, idx) => v[`option${idx + 1}`] === val);
      });
    }

    function updateUI() {
      const selected = getSelectedOptions();
      const variant = findVariant(selected);
      const addBtn = form.querySelector('[data-add-to-cart-btn]');
      if (variant) {
        idInput.value = variant.id;
        if (priceEl) {
          priceEl.innerHTML = variant.compare_at_price > variant.price
            ? `<span class="price--sale">Rs. ${(variant.price / 100).toFixed(0)}</span> <span class="price__compare">Rs. ${(variant.compare_at_price / 100).toFixed(0)}</span>`
            : `Rs. ${(variant.price / 100).toFixed(0)}`;
        }
        if (addBtn) {
          addBtn.disabled = !variant.available;
          addBtn.textContent = variant.available ? (addBtn.dataset.addLabel || 'Add to cart') : 'Sold out';
        }
        if (variant.featured_image) {
          const mainImg = qs('[data-product-gallery-main] img');
          if (mainImg) mainImg.src = variant.featured_image.src;
        }
      } else if (addBtn) {
        addBtn.disabled = true;
        addBtn.textContent = 'Unavailable';
      }
    }

    form.addEventListener('change', updateUI);
    updateUI();
  });

  /* ---------------- Product gallery thumbnails ---------------- */
  qsa('[data-gallery-thumb]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const gallery = thumb.closest('[data-product-gallery]');
      const mainImg = gallery.querySelector('[data-product-gallery-main] img');
      if (mainImg) mainImg.src = thumb.dataset.fullSrc;
      gallery.querySelectorAll('[data-gallery-thumb]').forEach(t => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
    });
  });

  /* ---------------- Quick add (product cards) ---------------- */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    const variantId = btn.dataset.quickAdd;
    if (!variantId) { window.location.href = btn.dataset.productUrl; return; }
    btn.disabled = true;
    const originalText = btn.textContent;
    btn.textContent = 'Adding...';
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
      if (!res.ok) throw new Error('Could not add');
      await refreshCartDrawer();
      cartDrawer && cartDrawer.classList.add('is-open');
      overlay && overlay.classList.add('is-visible');
    } catch (err) {
      window.location.href = btn.dataset.productUrl;
    } finally {
      btn.disabled = false;
      btn.textContent = originalText;
    }
  });

})();

/* ==========================================================================
   PREMIUM ANIMATION LAYER — scroll reveal + cursor glow (added on request)
   ========================================================================== */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    // auto-tag common blocks for scroll reveal so no template edits are required
    document.querySelectorAll('.section-heading, .product-grid, .footer-grid, .testimonials, .image-with-text__content, .image-with-text__media')
      .forEach(function (el) { el.classList.add(el.classList.contains('product-grid') || el.classList.contains('footer-grid') ? 'reveal-stagger' : 'reveal'); });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.15 });
    document.querySelectorAll('.reveal, .reveal-stagger').forEach(function (el) { io.observe(el); });

    // cursor glow (desktop only)
    if (window.matchMedia('(hover: hover)').matches) {
      var glow = document.createElement('div');
      glow.id = 'anysup-glow';
      document.body.appendChild(glow);
      document.addEventListener('mousemove', function (e) {
        glow.style.left = e.clientX + 'px';
        glow.style.top = e.clientY + 'px';
        glow.classList.add('on');
      });
      document.addEventListener('mouseleave', function () { glow.classList.remove('on'); });
    }

    // toast zone for lightweight feedback (add-to-cart etc. can call window.anysupToast)
    var zone = document.createElement('div');
    zone.className = 'anysup-toast-zone';
    document.body.appendChild(zone);
    window.anysupToast = function (msg) {
      var el = document.createElement('div');
      el.className = 'anysup-toast';
      el.textContent = msg;
      zone.appendChild(el);
      setTimeout(function () {
        el.classList.add('hide');
        setTimeout(function () { el.remove(); }, 350);
      }, 2600);
    };

    // bump cart count on change (works alongside existing cart drawer logic)
    document.addEventListener('cart:updated', function () {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.classList.add('bump');
        setTimeout(function () { el.classList.remove('bump'); }, 300);
      });
    });
  });
})();
